import React from "react";

export const Login = React.lazy(
  () => import("@/features/auth/pages/LoginPage.tsx"),
);
